module.exports = __webpack_public_path__ + "img/214.1c21be70.jpg";